import Forecast from "../components/forecast/Forecast"

function CustomerForecast() {
  return <Forecast />
}

export default CustomerForecast
